import { render, staticRenderFns } from "./StyledQRCode.vue?vue&type=template&id=3872dbbc&"
import script from "./StyledQRCode.vue?vue&type=script&lang=js&"
export * from "./StyledQRCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports